import MatBiMIcon from "@/assets/logos/MatBiMIcon";
import TechBimIcon from "@/assets/logos/TechBimIcon";
import { OutputData } from "@editorjs/editorjs";
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";
import { unescape } from "lodash";
import { useTranslation } from "react-i18next";

interface LibraryLinksProps {
    data: OutputData;
}

const linkRegex = /<a href="([^"]+)">([^<]+)<\/a>/g;

const LibraryLinks = ({ data }: LibraryLinksProps) => {
    const { t } = useTranslation("elements");

    if (!data?.blocks) return null;

    const links =
        data?.blocks
            .map((block) => {
                if (block.type !== "paragraph") return null;

                const content = block.data.text;
                const matches = content.match(linkRegex);
                if (!matches) return null;

                const links = matches.map((match: string) => {
                    const [, href] = match.match(/<a href="([^"]+)">([^<]+)<\/a>/) || [];
                    return { href: unescape(href) };
                });

                return links;
            })
            .flat()
            .filter(Boolean) ?? [];

    return (
        <div>
            {links?.map((link, index) => {
                if (link.href.includes("techbim"))
                    return (
                        <a
                            key={index}
                            href={link.href}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="mt-5 flex w-fit px-7.5 py-5 bg-[#00528B]/15 hover:bg-[#00528B]/25 rounded-lg items-center cursor-pointer text-base/snug text-[#00528B] font-bold h-[94px]"
                        >
                            <TechBimIcon /> <span className="ml-5">{t("buttons.techbim", { ns: "elements" })}</span>
                            <ArrowTopRightOnSquareIcon className="ml-1 mb-3 w-4 h-4" />
                        </a>
                    );

                if (link.href.includes("matbim"))
                    return (
                        <a
                            key={index}
                            href={link.href}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="mt-5 flex w-fit px-7.5 py-5 bg-[#00528B]/15 hover:bg-[#00528B]/25 rounded-lg items-center cursor-pointer text-base/snug text-[#00528B] font-bold h-[94px]"
                        >
                            <MatBiMIcon /> <span className="ml-7">{t("buttons.matbim", { ns: "elements" })}</span>
                            <ArrowTopRightOnSquareIcon className="ml-1 mb-3 w-4 h-4" />
                        </a>
                    );

                return null;
            })}
        </div>
    );
};

export default LibraryLinks;
